<div class="content-block light-control-host">
  <h1>Need Support?</h1>
  <p>The Arpio team is ready to help. We typically reply within 4 business hours.</p>
  <button type="button" class="link-button arpio-button" (click)="showTicketForm()">Open a Ticket</button>
  <h2 class="margin-top block-header">Want to talk with us instead?</h2>
  <p>
    Feel free to launch a live chat with our team. We are available between 9am-9pm Eastern Time, Monday - Friday. For
    urgent issues, you can call us anytime.
  </p>
  <div>
    <button type="button" class="link-button arpio-button" (click)="uiService.openChat()">Chat with Us</button>
    <a href="tel:{{ supportNumber }}">
      <button type="button" class="arpio-button link-button arpio-danger-button">Call {{ supportNumber }}</button>
    </a>
  </div>
  <p>
    If the above methods are not working, we also have a
    <a [routerLink]="" (click)="showBackupNumber()">backup phone number</a>.
  </p>
  @if (backupNumberVisible) {
    <p>
      Backup number: <a href="tel:{{ backupNumber }}">{{ backupNumber }}</a>
    </p>
  }
</div>

<modal-dialog #submitTicketDialog [dialogTemplate]="submitTicketDialogTemplate"></modal-dialog>
<ng-template #submitTicketDialogTemplate>
  <div class="flex-left-column light-control-host">
    <div class="modal-header">
      <h3 class="panel-title">Open a Ticket</h3>
      <button
        type="button"
        class="modal-close-btn"
        (click)="hideTicketForm()"
        [disabled]="openingTicket"
        pTooltip="Close"
        tooltipPosition="left"
        aria-label="Close"
      >
        <svg lucideX></svg>
      </button>
    </div>
    <div class="modal-subtitle">Tell us what's going on and we'll get back to you within 4 business hours.</div>
    <form id="supportTicketForm" class="support-form" [formGroup]="createTicketFormModel" (ngSubmit)="openTicket()">
      <fieldset style="grid-column: 1; grid-row: 1">
        <label for="yourEmail">Your email</label>
        <input id="yourEmail" class="arpio-input" type="email" formControlName="email" focus-element />
      </fieldset>
      <fieldset style="grid-column: 2; grid-row: 1">
        <label for="ticketPriority">Priority</label>
        <div class="select-wrapper">
          <select id="ticketPriority" class="arpio-select full-width" formControlName="ticketPriority">
            <option value="LOW" [selected]="true">Low</option>
            <option value="MEDIUM">Medium</option>
            <option value="HIGH">High</option>
          </select>
        </div>
      </fieldset>
      <fieldset style="grid-column: 1 / 3; grid-row: 2">
        <label for="ticketSubject">Subject</label>
        <input id="ticketSubject" class="arpio-input" type="text" formControlName="ticketSubject" />
      </fieldset>
      <fieldset style="grid-column: 1 / 3; grid-row: 3 / 5">
        <label for="ticketContent">Description</label>
        <textarea id="ticketContent" class="arpio-input" formControlName="ticketContent"></textarea>
      </fieldset>
    </form>
    <div class="modal-footer">
      <button type="button" class="arpio-secondary-button" (click)="hideTicketForm()" [disabled]="openingTicket">
        Cancel
      </button>
      <button
        type="submit"
        form="supportTicketForm"
        busy-button
        [busy]="openingTicket"
        class="arpio-button"
        [disabled]="createTicketFormModel.invalid"
      >
        Submit
      </button>
    </div>
  </div>
</ng-template>
<modal-dialog #confirmTicketDialog [dialogTemplate]="ticketConfirmationDialogTemplate"></modal-dialog>
<ng-template #ticketConfirmationDialogTemplate>
  <div class="flex-left-column light-control-host">
    <div class="modal-header">
      <h3 class="panel-title">Ticket opened</h3>
      <button
        type="button"
        class="modal-close-btn"
        (click)="confirmTicketDialog.close()"
        pTooltip="Close"
        tooltipPosition="left"
        aria-label="Close"
      >
        <svg lucideX></svg>
      </button>
    </div>
    <div class="ticket-confirmation-body" [innerHTML]="hubspotResponse"></div>
    <div class="modal-footer">
      <button type="button" class="arpio-secondary-button" (click)="confirmTicketDialog.close()">Close</button>
    </div>
  </div>
</ng-template>
